<div fxLayout="column">
  <mat-label>
    <h1>Your Information</h1>
  </mat-label>
</div>
<br>
<mat-tab-group *ngIf="!hideSecondaryApplicant" class="joint-tabs" id="joint-tab-group">
  <form [formGroup]="applicantsForm">
    <div *ngFor="let applicantGroup of applicantGroups; let indexOfElements = index;">
      <mat-tab label="{{getApplicantType(applicantGroup, indexOfElements)}}">
        <app-tell-us-about-yourself [formGroup]="getTellUsAboutYourselfFormGroup(applicantGroup)"
                                    [getPrimaryTellUsAboutYourselfData]="sendPrimaryTellUsAboutYourselfData"
                                    [reviewState]="reviewState"></app-tell-us-about-yourself>
        <mat-divider *ngIf="this.isMinor && this.hideSecondaryApplicant"></mat-divider>
        <app-employment-details *ngIf="getApplicantType(applicantGroup, indexOfElements) != 'Minor Applicant'"
                                [formGroup]="getEmploymentDetailsFormGroup(applicantGroup)"
                                [reviewState]="reviewState"></app-employment-details>
        <button (click)="selectSecondaryTab()" *ngIf="isPrimaryHasSecondary(applicantGroup) && reviewState === 0"
                class="navigation-button"
                mat-button>{{proceedLinkDetail}}</button>
        <div
          *ngIf="isSecondary(applicantGroup) && reviewState === reviewStates.ReadOnly && getApplicantType(applicantGroup, indexOfElements) != 'Adult Applicant'">
          <button (click)="removeSecondaryApplicantFromApplication()" class="navigation-button" color="red" mat-button>
            Remove Co-Applicant
          </button>
        </div>
        <button (click)="selectPrimaryTab()" *ngIf="isSecondary(applicantGroup) && reviewState === 0"
                class="navigation-button"
                mat-button>{{returnLinkDetail}}</button>
      </mat-tab>
    </div>
  </form>
</mat-tab-group>
<div *ngIf="hideSecondaryApplicant">
  <div *ngFor="let applicantGroup of applicantGroups; let first = first;">
    <form *ngIf="first" [formGroup]="applicantsForm">
      <app-tell-us-about-yourself [formGroup]="getTellUsAboutYourselfFormGroup(applicantGroup)"
                                  [isInJointMaintenanceFlow]="isInJointMaintenanceFlow"
                                  [reviewState]="reviewState"></app-tell-us-about-yourself>
      <app-employment-details
        *ngIf="!isAuthenticated"
        [formGroup]="getEmploymentDetailsFormGroup(applicantGroup)"
        [reviewState]="reviewState"></app-employment-details>
    </form>
  </div>
</div>
